<template>
  <div class="container" :style="comWidth ? 'width:' + comWidth + 'px;height:' + comHeight + 'px' : ''" >
    <div @click="goVideoInfo('/videoInfo', videoItem.id)" :style="comWidth ? 'width:' + comWidth + 'px;height:' + comHeight + 'px;'+ videoItem.cover ? 'backgroundImage:url('+videoItem.cover+');backgroundPosition: center;backgroundRepeat: no-repeat;':'' : videoItem.cover ? 'backgroundImage:url('+videoItem.cover+');backgroundPosition: center;backgroundRepeat: no-repeat;':''">
      <div  class="play" :style="comWidth ? 'width:' + comWidth + 'px;height:' + comHeight + 'px' : ''">
        <span class="iconfont" style="color: #fff; font-size: 30px" >&#xe62c;</span >
      </div>
    </div>
    <div class="info" v-if="!comWidth">
      <div class="title">
        {{ videoItem.title }} 
      </div>
      <div class="articleDesc">
        {{ videoItem.readCount }}人浏览 {{ videoItem.updateTimeStr }}
      </div>
    </div>
    <div class="infoCom" v-else>
      <div class="title" style="min-height: 17px;">
        {{ videoItem.title?videoItem.title:"" }} 
      </div>
      <div style="padding: 0px 0 0 0px; color: #bbbbbb">
          <div style="padding: 10px 0 0 0px; color: #bbbbbb">
            <span class="iconfont" style="margin-right: 4px; font-size: 18px; vertical-align: middle">&#xe636;</span>
            <span class="iconStyle" v-if="videoItem.status==0">审核中</span>
            <span class="iconStyle" v-if="videoItem.status==1">{{ videoItem.updateTime }}</span>
            <span class="iconStyle" v-if="videoItem.status==2" style="color: red" :title="videoItem.checkSuggest">未通过</span>
            <span class="iconStyle" v-if="videoItem.status==3">下架</span>
            <span class="iconStyle" v-if="videoItem.status==4">草稿</span>

            <span class="iconfont" style="margin: 0 4px 0 5px; vertical-align: middle" >&#xe680;</span >
            <span class="iconStyle">{{ videoItem.videoTime }}</span>
            <span v-if="linkFrom !='space' ">
              <span @click="delVideo(videoItem.id)">
                <span class="iconfont" style="margin: 0 4px 0 5px; vertical-align: middle; vertical-align: middle">&#xe61e;</span>
                <span class="iconStyle">删除</span>
              </span>
              <span @click="editVideo(videoItem.id)">
                <span class="iconfont" style="margin: 0 4px 0 5px; vertical-align: middle">&#xe690;</span>
                <span class="iconStyle">编辑</span>
              </span>
            </span>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import {deleteVideo} from "@/comm/api";

export default {
  name: "VideoV",
  components: {},
  data() {
    return {};
  },
  props: {
    videoItem: {
    },
    comWidth: {
      type: Number,
      default: null
    },
    comHeight: {
      type: Number,
      default: null
    },
    linkFrom: {
      //标明数据来源：该页面个人空间、创作中心首页、草稿箱共用
      type: String,
      default: null
    }
  },
  methods: {
    goVideoInfo(url, id) {
      const { href } = this.$router.resolve({
        path: url+"?id="+id
      });
      window.open(href, "_blank");
    },
    async delVideo(id){
      await deleteVideo({id:id});
      this.$emit("submit-loadPage");
    },
    editVideo(id){
      let routeData = this.$router.resolve({ path: '/creativeCenter', query: {"viewKey": "4-2","resourceId":id } });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>
<style lang="stylus" scoped>
.container {
  width: 285px;
  // height 356px;
  background: white;

  .bg {
    width: 285px;
    height: 160px;
    background-size: 100% 100%;
    background-image: url('../assets/1.jpg');
    border-radius: 4px 4px 0 0;
  }

  .play {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 160px;
    cursor: pointer;
  }

  .info {
    padding: 14px;
    background: white;
    font-family: PingFangSC-Regular, PingFang SC;

    .title {
      font-size: 16px;
      font-weight: 400;
      color: #363636;
      line-height: 20px;
      cursor: pointer;
    }

    .articleDesc {
      font-size: 12px;
      font-weight: 400;
      color: #B8B9BA;
      line-height: 17px;
      margin-top: 8px;
    }
  }

  .infoCom {
    padding-top: 5px;
    background: white;
    font-family: PingFangSC-Regular, PingFang SC;

    .title {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
      width: 188px;
      cursor: pointer;
    }

    span {
      cursor: pointer;
    }

    .iconStyle {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #BBBBBB;
      line-height: 17px;
    }
  }
}
</style>
